/** Funções puras para cálculo de progresso. */

export function clampPercent(value: number): number {
  if (Number.isNaN(value)) return 0;
  return Math.max(0, Math.min(100, value));
}

/**
 * Calcula progresso por índice/total com offset de 0.5 (fase intermediária) e clamp em 99.
 */
export function progressByIndex(index: number, total: number, phase: 'progress' | 'file' | 'complete'): number {
  if (!total || total <= 0) return 0;
  let percent: number = 0;
  if (phase === 'progress') {
    percent = ((index + 0.5) / total) * 100;
    return Math.min(percent, 99);
  }
  if (phase === 'file') {
    percent = ((index + 1) / total) * 100;
    return Math.min(percent, 99);
  }
  return 100;
}


